/**
 * Configuration des 5 phases du workflow d'expertise immobilière.
 * Source unique de vérité utilisée par PhaseSidebar et PhaseProgressBar.
 */

export const PHASES = [
  {
    id: 1,
    label: 'Création du dossier',
    shortLabel: 'Création',
    sections: [
      { id: 'mission', label: 'Mission' },
      { id: 'designation', label: 'Désignation' },
    ],
  },
  {
    id: 2,
    label: 'Préparation',
    shortLabel: 'Préparation',
    sections: [
      { id: 'documents', label: 'Documents' },
      { id: 'rendez_vous', label: 'Rendez-vous' },
    ],
  },
  {
    id: 3,
    label: 'Visite',
    shortLabel: 'Visite',
    sections: [
      { id: 'description', label: 'Description', requiresBien: true },
      { id: 'photos', label: 'Photos' },
    ],
  },
  {
    id: 4,
    label: "Analyse de l'expertise",
    shortLabel: 'Analyse',
    sections: [
      { id: 'juridique', label: 'Analyse juridique', requiresBien: true },
      { id: 'technique', label: 'Analyse technique', requiresBien: true },
      { id: 'economique', label: 'Analyse économique' },
      { id: 'marche', label: 'Étude de marché' },
      { id: 'valorisation', label: 'Estimation de la valeur' },
    ],
  },
  {
    id: 5,
    label: 'Rapport',
    shortLabel: 'Rapport',
    sections: [
      { id: 'synthese', label: 'Synthèse' },
      { id: 'bcg', label: 'BCG', conditional: 'bcg' },
    ],
  },
];

const ALL_SECTIONS = PHASES.flatMap((p) => p.sections.map((s) => s.id));

export function getPhaseForSection(sectionId) {
  return PHASES.find((p) => p.sections.some((s) => s.id === sectionId));
}

export function getSectionsForPhase(phaseId) {
  const phase = PHASES.find((p) => p.id === phaseId);
  return phase ? phase.sections : [];
}

export function getNextSection(currentSectionId) {
  const idx = ALL_SECTIONS.indexOf(currentSectionId);
  if (idx === -1 || idx === ALL_SECTIONS.length - 1) return null;
  return ALL_SECTIONS[idx + 1];
}

export function getPrevSection(currentSectionId) {
  const idx = ALL_SECTIONS.indexOf(currentSectionId);
  if (idx <= 0) return null;
  return ALL_SECTIONS[idx - 1];
}

export function getFirstSectionOfPhase(phaseId) {
  const sections = getSectionsForPhase(phaseId);
  return sections.length > 0 ? sections[0].id : null;
}
